module.exports = __webpack_public_path__ + "img/dg-handling.5e0bf1ce.jpg";